var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense, useEffect, useMemo } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
const bifilter = (filter, arr) => {
    const truthy = [];
    const falsey = [];
    arr.forEach((item) => {
        if (filter(item)) {
            truthy.push(item);
        }
        else {
            falsey.push(item);
        }
    });
    return [truthy, falsey];
};
const handlerRegExp = /^on[A-Z]/;
const partitionHandlerProps = (props) => {
    const [handlers, nonHandlers] = bifilter(([propName]) => handlerRegExp.test(propName), Object.entries(props));
    return [Object.fromEntries(handlers), Object.fromEntries(nonHandlers)];
};
const Null = () => null;
export const Icon = (_a) => {
    var { name = '' } = _a, props = __rest(_a, ["name"]);
    const [handlers] = partitionHandlerProps(props);
    const handlersLength = Object.keys(handlers).length;
    // Unmemoized handlers (`onClick`, etc) will cause flickering as they defeat the `useMemo` dependency array below
    useEffect(() => {
        if (handlersLength > 0) {
            console.warn('Use `InteractiveIcon` instead of `Icon` when using event handlers like `onClick`');
        }
    }, [handlersLength]);
    // Without a memoized version, rerendering of the same SVG icon sometimes causes a flicker. This stableizes it so it doesn't even try to rerender the same icon
    const StableIcon = useMemo(() => {
        const IconComponent = import(`./icons/${name}.js`);
        const LazyIcon = lazy(() => IconComponent);
        return _jsx(LazyIcon, Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", "data-testid": `icon:${name}` }, props));
    }, 
    // eslint doesn't recognize that what is happening here actually is being exhaustive in the dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [name, ...Object.values(props)]);
    return _jsx(Suspense, Object.assign({ fallback: _jsx(Null, {}) }, { children: StableIcon }));
};
Icon.propTypes = {
    name: propTypes.string,
};
const NoStyleButton = styled.button.withConfig({ displayName: "brc-NoStyleButton", componentId: "brc-txfkav" }) `
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: inherit;
  outline: inherit;
  line-height: 0;
`;
/** Pass all event handler props to a wrapper button to avoid rerendering the icon and causing flicker */
const InteractiveIconInternal = (props) => {
    const [handlers, nonHandlers] = partitionHandlerProps(props);
    return (_jsx(NoStyleButton, Object.assign({}, handlers, { children: _jsx(Icon, Object.assign({}, nonHandlers)) })));
};
InteractiveIconInternal.propTypes = {
    name: propTypes.string,
};
export const InteractiveIcon = styled(InteractiveIconInternal).withConfig({ displayName: "brc-InteractiveIcon", componentId: "brc-1ajtlo0" }) ``;
export default styled(Icon).withConfig({ componentId: "brc-u4865c" }) ``;
//# sourceMappingURL=icon.js.map